import { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { isInstanceRunning } from '../../../apis/constants';
import { instanceApis } from '../../../apis/instanceApis';
import { serverApis } from '../../../apis/serverApis';
import AlertMessage from '../../../components/elements/alert-message/AlertMessage';
import Loading from '../../../components/elements/loading/Loading';
import Storage from '../../../components/elements/storage/Storage';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import InstanceInfo from '../../../components/sections/overview/InstanceInfo';
import Overview from '../../../components/sections/overview/Overview';

const ServerOverviewPage = () => {
  const { projectId, gpsId } = useParams();
  const { t } = useTranslation();

  const [gps, setGps] = useState(null);
  const [storage, setStorage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: gpsRes } = await serverApis.getServer(projectId, gpsId);
      setGps(gpsRes);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchStorage = async () => {
    // Check to see if this is working on backend. If not, remove.
    const storageRes =
      isInstanceRunning(gps) &&
      (await instanceApis.getStorage(projectId, gpsId));

    setStorage(storageRes.data);
  };

  useEffect(() => {
    if (!gps) return;
    fetchStorage();
  }, [gps]);

  if (loading) return <Loading />;

  if (error)
    return (
      <AlertMessage
        severity="error"
        message={t('fetchServerError', { ns: 'notifications' })}
      />
    );

  return (
    <Container>
      <Breadcrumbs serverName={gps.name} />
      <Overview data={gps} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <InstanceInfo instance={gps} />
        {storage && (
          <Storage
            available={Number(storage.available)}
            total={Number(storage.size)}
          />
        )}
      </Box>
    </Container>
  );
};

export default ServerOverviewPage;
